import { render, staticRenderFns } from "./ServicesListWidget.vue?vue&type=template&id=825de5b2"
import script from "./ServicesListWidget.vue?vue&type=script&lang=js"
export * from "./ServicesListWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports